var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-alert',{attrs:{"type":_vm.isUnique ? 'success' : 'warning',"message":_vm.message}})
}
var staticRenderFns = []

export { render, staticRenderFns }